import { render, staticRenderFns } from "./RentalcompanyCodeItemSimpleCard.vue?vue&type=template&id=58fbb631&scoped=true"
import script from "./RentalcompanyCodeItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./RentalcompanyCodeItemSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./RentalcompanyCodeItemSimpleCard.vue?vue&type=style&index=0&id=58fbb631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fbb631",
  null
  
)

export default component.exports